/**
 * What the MODEL sees when the recipe search finds nothing. Written for the
 * model, never the user: search_knowledge used to be a pass-through tool and
 * "No results found" reached users as the whole answer (prod, 2026-09-28..30).
 */
export const NO_RECIPE_MATCH =
  'No matching trading term, column, scan, strategy, backtest template or Playbook play. This search only covers those; for how-to or "where is it" questions call get_platform_guide.'
